<nav class="navbar navbar-expand-lg bg-body-tertiary" style="height: 105.52px;padding: 0%;margin-bottom:0%">
  <div class="container-fluid" style="padding-left: 35px;">
    <div class="logo" style="padding-right: 35px;">
      <a class="visible-on-sidebar-regular">
        <div class="logo-img ">
          <img style="height:51.94px; width: 171.4px;" src="/assets/img/logo.png" alt="" />
        </div>
      </a>
      <a class="visible-on-sidebar-mini">
        <div class="logo-img ">
          <img style="height:50px; " src="/assets/img/isotipo.png" alt="" />
        </div>
      </a>
    </div>
    <div class="navbar-wrapper">
      <div class="navbar-minimize visible-on-sidebar-mini">
        <!-- <button mat-raised-button (click)="minimizeSidebar()" class="btn btn-just-icon btn-white btn-fab">
          <i class="material-icons text_align-center visible-on-sidebar-regular">more_vert</i>
          <i class="material-icons design_bullet-list-67 visible-on-sidebar-mini">view_list</i>
        </button> -->
      </div>
      <!--       <a class="navbar-brand" href="{{getPath()}}"> {{getTitle()}}</a>
 -->
    </div>
    <button class="navbar-toggler btn-no-ripple" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav"
      (click)="sidebarToggle()">
      <span class="navbar-toggler-icon icon-bar"></span>
      <span class="navbar-toggler-icon icon-bar"></span>
      <span class="navbar-toggler-icon icon-bar"></span>
      
    </button>
    
    <div class="collapse navbar-collapse" id="navbarNav">
      <ul class="navbar-nav">
        <!--  <form class="d-flex" role="search">
          <input class="form-control me-2" type="search" placeholder="Buscar" aria-label="Search">
           <button class="btn btn-outline-success" type="submit">Search</button>
        </form> -->
        <li routerLinkActive="active" *ngFor="let menuitem of menuItems" class="nav-item" style="color: #BDBDBD;">
          <!--If is a single link-->
          <a [routerLink]="[menuitem.path]" *ngIf="menuitem.type === 'link'" class="nav-link" style="font-size: 16px;">
            <!-- <i class="material-icons">{{menuitem.icontype}}</i> -->
            {{menuitem.title}}
          </a>
          <!--If it have a submenu-->
          <a data-toggle="collapse" href="#Menu{{menuitem.collapse}}" *ngIf="menuitem.type === 'sub'"
            (click)="updatePS()" class="nav-link" style="font-size: 16px;">
            {{menuitem.title}}
          </a>

          <!--Display the submenu items-->
          <div id="Menu{{menuitem.collapse}}" class="collapse" *ngIf="menuitem.type === 'sub'">
            <ul class="nav">
              <li routerLinkActive="active" *ngFor="let childitem of menuitem.children" class="nav-item">
                <a [routerLink]="[childitem.path]" class="nav-link" *ngIf="childitem.ab != 'XXXX'">
                  <span class="sidebar-mini">{{childitem.ab}}</span>
                  <span class="sidebar-normal">{{childitem.title}}</span>
                </a>
              </li>
             
            </ul>
            
          </div>

        </li>
   
   <!--      <li class="nav-item dropdown" style="padding: 0%;">
          <a
            data-mdb-dropdown-init
            class="nav-link dropdown-toggle d-flex align-items-center"
            href="#"
            id="navbarDropdownMenuLink"
            role="button"
            aria-expanded="false"
          >
             <i class="material-icons" style="color: #9CD41C;">person</i>
          </a>
          <ul class="dropdown-menu" aria-labelledby="navbarDropdownMenuLink">
            <li>
              <a class="dropdown-item" href="#">My profile</a>
            </li>
            <li>
              <a class="dropdown-item" href="#">Settings</a>
            </li>
            <li>
              <a class="dropdown-item" href="#">Logout</a>
            </li>
          </ul>
        </li> -->
      </ul>
    </div>
    <div class="collapse navbar-collapse justify-content-end" id="navigation">

      <ul class="navbar-nav">

        <li class="nav-item dropdown">
          <a *ngIf="!isAsociadoPre" class="nav-link" href="#" id="navbarDropdownMenuLink" data-toggle="dropdown"
            aria-haspopup="true" aria-expanded="false">
            <i class="material-icons">notifications</i>
            <span class="notification">0</span>
            <p>
              <span class="d-lg-none d-md-block">Some Actions</span>
            </p>
          </a>
          <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdownMenuLink">

          </div>
        </li>

        <li class="nav-item dropdown">
          <a class="nav-link" href="#" id="navbarDropdownMenuUser" data-toggle="dropdown" aria-haspopup="true"
            aria-expanded="false">
            <i class="material-icons">person</i>
           <!--  {{dataUser.Nombre+ " "+ dataUser.Apellidos}} -->
          </a>
          <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdownMenuUser">
            <a *ngIf="isAsociado" class="dropdown-item" (click)="ValidChangePassword()">
              <i class="fa fa-refresh"> </i>&nbsp; Cambiar Contraseña</a>
            <a class="dropdown-item" routerLink="/publico/Logout">
              <i class="fa fa-sign-out fa-fw"> </i>&nbsp; Salir</a>

          </div>
        </li>
      </ul>
    </div>
  </div>
  <!--   <app-navbar-cmp></app-navbar-cmp> -->
</nav>
